module.exports = __webpack_public_path__ + "img/4.f9b1f175.png";